import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { getPlans } from "../store/slices/plan";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import HeaderNavbar from "./Navbar";
import Footer from "./Footer";

export default function UserMembership() {
  const { planslist = [] } = useSelector((state) => state.plan);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  useEffect(() => {
    dispatch(getPlans());
  }, [dispatch]);

  const getFeatureList = (plan) => {
    const durationLabel =
      plan.durationType === "years"
        ? plan.duration > 1
          ? "Years"
          : "Year"
        : plan.duration > 1
          ? "Months"
          : "Month";

    return [
      {
        text: `Valid for ${plan.duration} ${durationLabel}`,
        enabled: true,
      },
      {
        text:
          plan.limits?.chats === -1
            ? "Unlimited Chat"
            : `${plan.limits?.chats || 0} Chats`,
        enabled: true,
      },
      {
        text:
          plan.limits?.contactViews === -1
            ? "Unlimited Contact Views"
            : `${plan.limits?.contactViews || 0} Contact Views`,
        enabled: true,
      },
      {
        text: "Verified Badge",
        enabled: !!plan.features?.verifiedBadge,
      },
      {
        text: "Profile Highlight",
        enabled: !!plan.features?.profileHighlight,
      },
    ];
  };

  const isBestSeller = (index) => index === 2;

  return (
    <>
      <HeaderNavbar />

      <div style={{
        background: "#f8f5f2",
        padding: "60px 0",
        textAlign: "center",
      }}>
        <h1 style={{ color: "#7b1e3b", fontWeight: "600" }}>Membership Plans</h1>
      </div>

      {/* <--- >Plans */}
      <Container className="plans-section">
        {planslist.length === 0 ? (
          <div className="plans-loading">Loading plans...</div>
        ) : (
          <Row className="justify-content-center">
            {planslist.map((plan, index) => (
              <Col lg={3} md={6} key={plan._id} className="mb-4">
                <div className="plan-card">

                  {/* ---- > Badge */}
                  {/* {isBestSeller(index) && (
                    <div className="bestseller-badge">Best Seller</div>
                  )} */}

                  {/* Plan -----  > Name */}
                  <h4 className="plan-name text-center">{plan.name}</h4>


                  {/* Description <------ */}
                  {plan.description && (
                    <p className="plan-description text-center">{plan.description}</p>
                  )}

                  {/* Price */}
                  <div className="text-center mt-2">
                    {plan.originalPrice && plan.originalPrice > plan.price && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "10px",
                          marginBottom: "6px",
                        }}
                      >
                        <span
                          style={{
                            background: "#28a745",
                            color: "#fff",
                            fontSize: "12px",
                            padding: "3px 10px",
                            borderRadius: "20px",
                            fontWeight: "600",
                          }}
                        >
                          {Math.round(
                            ((plan.originalPrice - plan.price) / plan.originalPrice) * 100
                          )}
                          % OFF
                        </span>

                        <span
                          style={{
                            fontSize: "20px",
                            color: "#393838",
                            textDecoration: "line-through",
                            fontWeight: 500,
                          }}
                        >
                          ₹{plan.originalPrice.toLocaleString("en-IN")}
                        </span>
                      </div>
                    )}

                    <div>
                      <span
                        className="plan-price"
                        style={{
                          fontSize: "32px",
                          fontWeight: "700",
                          color: "#7b1e3b",
                        }}
                      >
                        ₹{plan.price.toLocaleString("en-IN")}
                      </span>
                    </div>

                    <div
                      style={{
                        fontSize: "12px",
                        color: "#6c757d",
                        marginTop: "6px",
                      }}
                    >
                      * Taxes as applicable (18% GST extra)
                    </div>
                  </div>


                  {/*  Feature List <-------- */}
                  <ul className="plan-features">
                    {getFeatureList(plan).map((feature, index) => (
                      <li
                        key={index}
                        style={{
                          color: feature.enabled ? "#000" : "#999",
                          opacity: feature.enabled ? 1 : 0.6,
                        }}
                      >
                        {feature.enabled ? "✔" : "✖"} {feature.text}
                      </li>
                    ))}
                  </ul>

                  {/* Pay Button */}
                  <button className="plan-pay-btn" onClick={() => navigate("/register")}>
                    Buy Now
                  </button>
                </div>
              </Col>
            ))}
          </Row>
        )}
      </Container>
      <Footer />
    </>
  );
}